import { Text } from "@meditect/medibase-components";

/** @INFO : define a scenario to handle this issue instead of asking to contact the support*/
export const InventoriesCannotInventoryArchivedStockItemError = () => {
  return (
    <Text>
      Vous ne pouvez pas mettre à jour l'inventaire car des lignes de stocks ont été archivées durant l'inventaire.
      Contactez le support.
    </Text>
  );
};
